import axios from "axios";

export const getAllPages = async (firstResponseOrUrl, cancelToken) => {
  let response = typeof firstResponseOrUrl === 'string'
    ? await axios.get(firstResponseOrUrl, { removeTrailingSlash: true, cancelToken })
    : firstResponseOrUrl;

  let results = [];

  while (response) {
    results = results.concat(response.data.results);

    response = response.data.next
      ? await axios.get(response.data.next, { removeTrailingSlash: true, cancelToken })
      : null;
  }

  return results;
};
